export default __webpack_public_path__ + "static/media/zaglushka_logo.68fc9df6.png";